import { Box, colors, Theme, Tooltip } from "@mui/material"
import { BiErrorCircle } from "react-icons/bi"

const messages = {
	blank: "数字か文字を入力する必要があります",
	not_a_number: "数字を入力してください",
	foreign_key: "参照先のテーブルに指定したIDが存在しません",
}
const tooltipSx = {
	backgroundColor: colors.red[400],
}
const arrowSx = {
	color: colors.red[400],
}

type ErrorKey = keyof typeof messages
export const ErrorIcon = (props: { errors: string[]; mt?: string; rightSpace?: boolean }) => {
	const { rightSpace = false } = props
	const list = (
		<>
			{props.errors.map((error, i) => (
				<Box key={i}>{messages[error as ErrorKey] || error}</Box>
			))}
		</>
	)

	// tooltip customize: https://stackoverflow.com/a/54606987/1979795
	return (
		<Tooltip
			placement="top"
			title={list}
			componentsProps={{ tooltip: { sx: tooltipSx }, arrow: { sx: arrowSx } }}
			arrow
		>
			<Box
				position="absolute"
				top="50%"
				mt={props.mt}
				sx={(theme: Theme) => ({
					transform: "translateY(-50%)",
					right: theme.spacing(rightSpace ? 4 : 1),
					width: "20px",
					height: "20px",
					textAlign: "center",
				})}
				data-testid="alert"
			>
				<BiErrorCircle color={colors.red[400]} />
			</Box>
		</Tooltip>
	)
}
